<template>
  <div class="wrapper">
    <div class="header d-flex justify-content-center">
      <p class="custom-title vp-mb-0">{{ $t('journeyBuilder.form.disableTouchMode') }}</p>
      <svg
        class="closeModal"
        @click="$bvModal.hide('showConfirmationToDisableTouchModeModal')"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11 0C4.91333 0 0 4.91333 0 11C0 17.0867 4.91333 22 11 22C17.0867 22 22 17.0867 22 11C22 4.91333 17.0867 0 11 0ZM16.5978 14.7156C17.1111 15.2289 17.1111 16.06 16.5978 16.5733C16.3289 16.8422 16.0111 16.9644 15.6689 16.9644C15.3267 16.9644 14.9844 16.8422 14.74 16.5733L11.0733 12.9067L7.38222 16.5733C7.11333 16.8422 6.79556 16.9644 6.45333 16.9644C6.11111 16.9644 5.76889 16.8422 5.52444 16.5733C5.01111 16.06 5.01111 15.2289 5.52444 14.7156L9.21556 11.0244L5.52444 7.35778C5.01111 6.84444 5.01111 6.01333 5.52444 5.5C6.03778 4.98667 6.86889 4.98667 7.38222 5.5L11.0733 9.19111L14.7644 5.5C15.2778 4.98667 16.1089 4.98667 16.6222 5.5C17.1356 6.01333 17.1356 6.84444 16.6222 7.35778L12.9311 11.0489L16.5978 14.7156Z"
          fill="#F46A6A"
        />
      </svg>
    </div>
    <div class="content vp-mb-40">
        <div class="vp-mb-24"><span class="content-note">{{ $t('journeyBuilder.form.areYouSureYouWantDisableTouchMode') }}</span></div>
        <div><span class="content-note">{{ $t('journeyBuilder.form.disablingTouchModeWillRemoveAllPdfAndImageAgreementsFromEveryFlow') }}</span></div>
    </div>
    <hr class="h-line" />
    <div class="action-btns">
        <button @click="disableTouchMode('disabled')" class="dismiss-action-btn btn btn-primary vp-mr-32" size="md">
        {{ $t('common.disable') }}
        </button>
        <button @click="disableTouchMode('cancel')" class="cancel-btn btn" size="md">
        {{ $t('common.cancel') }}
        </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "ComplianceDetailsModal",
  props: ["previewData"],
  computed: {
    ...mapGetters("journey", [
      "getIsValidateRemoteJourney",
    ]),
  },
  methods: {
    disableTouchMode(type) {
      this.$emit("disableTouchMode", type);
    },
  },
};
</script>

<style lang="scss">
  #showConfirmationToDisableTouchModeModal___BV_modal_content_ {
    border-radius: 26px;

    .content ul {
      list-style: disc outside !important;
      margin-left: 40px;
      li{
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 24px;
        letter-spacing: 0%;
        vertical-align: middle;
        color: #4A4A4A;
      }
    }

    .head-text{
      margin-bottom: 24px;
      font-weight: 400;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0%;
      vertical-align: middle;
      color: #4A4A4A;
    }

    .h-line {
      opacity: 0.15;
      background: #707070;
      width: 420px;
      margin: 0px auto 24px auto;
    }
    .action-btns {
        .dismiss-action-btn {
            background: #103f5e;
            border-radius: 16.6275px;
            width: 112px;
            height: 32px;
            color: #ffffff;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            text-align: center;
            width: 112px;
            height: 32px;
        }
        .cancel-btn {
            align-items: center;
            display: flex;
            border: 1.5px solid #f46a6a;
            border-radius: 16.6275px;
            justify-content: center;
            color: #f46a6a;
            font-weight: 400;
            font-size: 16px;
            line-height: 17px;
            text-align: center;
            width: 112px;
            height: 32px;
        }
    }

    .content-note {
        font-weight: 400;
        font-size: 16px;
        line-height: 100%;
        letter-spacing: 0%;
        vertical-align: middle;
        color: #4A4A4A;
    }

  }
</style>

<style lang="scss" scoped>
  .header {
    margin-bottom: 40px;
    .custom-title {
      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0%;
      text-align: center;
      color: #000000;
    }
  }
  .close-icon {
    position: absolute;
    top: 21px;
    inset-inline-end: 26px;
    color: #f46a6a;
    font-size: 1.7rem;
    cursor: pointer;
  }

  .closeModal {
    position: absolute;
    top: 32px;
    inset-inline-end: 32px;
    cursor: pointer;
  }
</style>


